import Form from '../__core/Form';
import component from './component.vue';

export default class FItem extends Form {
  component = component;

  __component = null;

  constructor(props = {}) {
    super(props);
    if (props.required) {
      this.setValidatorRequire();
    }
    if (props.right) {
      this.right = props.right;
    }
    if (props.icon) {
      this.icon = props.icon;
    }
  }

  setValidatorRequire(message = 'Обязательное') {
    this.setValidator((value) => {
      if (!value) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, true);
    return this;
  }

  toString() {
    return this.value || '';
  }
}
